import axios from 'axios'

//验收列表
export function getInspectionSheetItemQueryList (data) {
  return axios.get(`/manage/inspectionSheetItem/queryList`, { params: data })
}

//验收列表
export function getInspectionSheetItemList (data) {
  return axios.get(`/manage/inspectionSheetItem/list`, { params: data })
}

//验收详情
export function getInspectionSheetItem (id) {
  return axios.get(`/manage/inspectionSheetItem/${id}`)
}